// extracted by mini-css-extract-plugin
export default {"burgerMenuContainer":"BurgerMenu_burgerMenuContainer__xnScq","burgerMenuList":"BurgerMenu_burgerMenuList__OEB6y"};